class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle?.querySelector('summary');
    this.desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverCloseTimeout = null;

    this.onMouseEnter = this.handleMouseEnter.bind(this);
    this.onMouseLeave = this.handleMouseLeave.bind(this);
    this.onSummaryClick = this.handleSummaryClick.bind(this);

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
    }

    if (this.summary) {
      this.summary.addEventListener('click', this.onSummaryClick);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  handleMouseEnter() {
    if (!this.desktopHoverQuery.matches) return;
    if (this.hoverCloseTimeout) {
      window.clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary?.setAttribute('aria-expanded', true);
  }

  handleMouseLeave() {
    if (!this.desktopHoverQuery.matches) return;
    this.hoverCloseTimeout = window.setTimeout(() => {
      this.close();
      this.hoverCloseTimeout = null;
    }, 100);
  }

  handleSummaryClick(event) {
    if (!this.desktopHoverQuery.matches) return;
    if (event.detail > 0) event.preventDefault();
  }
}

customElements.define('header-menu', HeaderMenu);
